import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Send, Pause, Archive } from 'lucide-react';
import { inviteApi } from '../../lib/inviteApi';
import InviteStatusBadge from '../../components/invite/InviteStatusBadge';

export default function FollowupsTab({ exhibitionId, onNavigate }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const d = await inviteApi.listFollowupsDue(exhibitionId);
      setItems(d.items || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [exhibitionId]);

  const pause = async (id) => { await inviteApi.pauseAgent(id); toast.success('Paused'); refresh(); };
  const archive = async (id) => { await inviteApi.archiveThread(id); toast.success('Archived'); refresh(); };

  return (
    <div className="space-y-4" data-testid="followups-tab">
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-mono text-[#777]">{items.length} thread(s) ready for follow-up. Nothing is auto-sent.</p>
        <button onClick={refresh} data-clickable="true" className="text-[10px] font-mono px-3 py-1.5 border border-[#333] text-[#aaa] hover:text-white uppercase tracking-[0.14em]">Refresh</button>
      </div>
      {loading && <p className="text-xs font-mono text-[#555]">Loading…</p>}
      {!loading && !items.length && <p className="text-xs font-mono text-[#555]">No follow-ups due.</p>}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {items.map((it) => (
          <div key={it.thread.id} className="border border-[#1a1a1a] bg-[#0a0a0a] p-4">
            <div className="flex items-center justify-between mb-1.5">
              <p className="text-xs font-mono text-white">{it.thread.id.slice(0, 8)}…</p>
              <InviteStatusBadge status={it.followup_type} />
            </div>
            <p className="text-[11px] font-mono text-[#888]">
              Initial sent: {it.thread.last_outbound_at ? new Date(it.thread.last_outbound_at).toLocaleDateString() : '—'}
            </p>
            <p className="text-[11px] font-mono text-[#888]">
              Due: {(it.thread.followup_2_due_at || it.thread.followup_1_due_at) ? new Date(it.thread.followup_2_due_at || it.thread.followup_1_due_at).toLocaleString() : '—'}
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <button onClick={() => onNavigate?.('conversations', { threadId: it.thread.id })} data-clickable="true" data-testid={`followup-open-${it.thread.id}`} className="inline-flex items-center gap-1.5 text-[10px] font-mono px-2.5 py-1.5 border border-[#90E0EF]/40 text-[#90E0EF] hover:bg-[#90E0EF]/10 uppercase tracking-[0.14em]">
                <Send className="w-3 h-3"/> Open & send
              </button>
              <button onClick={() => pause(it.thread.id)} data-clickable="true" className="inline-flex items-center gap-1.5 text-[10px] font-mono px-2.5 py-1.5 border border-[#333] text-[#aaa] hover:text-white uppercase tracking-[0.14em]">
                <Pause className="w-3 h-3"/> Pause
              </button>
              <button onClick={() => archive(it.thread.id)} data-clickable="true" className="inline-flex items-center gap-1.5 text-[10px] font-mono px-2.5 py-1.5 border border-[#333] text-[#aaa] hover:text-white uppercase tracking-[0.14em]">
                <Archive className="w-3 h-3"/> Archive
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
